import React from 'react';
import { Link } from 'react-router-dom';
import Button from './ui/Button';

type BlogMiniArticleCardProps = {
  image: string;
  title: string;
  description: string;
  tag: string;
  date: string;
  readTime: string;
  slug: string;
};

const BlogMiniArticleCard: React.FC<BlogMiniArticleCardProps> = ({
  image,
  title,
  description,
  tag,
  date,
  readTime,
  slug,
}) => (
  <article className="flex gap-3 pb-3 border-b border-gray-100 items-stretch">
    <img src={image} alt={title} className="w-[92px] h-auto self-stretch object-cover rounded-xl flex-shrink-0" />
    <div className="min-w-0 flex-1">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1 text-gray-400 font-title text-[9px] uppercase font-bold tracking-wider">
          <span>{tag}</span>
          <span>·</span>
          <span>{date}</span>
        </div>
        <span className="text-gray-400 font-title text-[9px] font-bold">{readTime}</span>
      </div>
      <h5 className="mt-1 line-clamp-2 text-gray-900 font-title text-[14px] font-bold leading-snug">
        {title}
      </h5>
      <p className="mt-1 line-clamp-2 text-gray-500 font-description text-[9px]">
        {description}
      </p>
      <Link to={`/blog/${slug}`}>
        <Button type="button" unstyled className="mt-1 inline-flex items-center gap-1 text-gray-900 font-title text-[10px] font-bold hover:text-primary transition-colors">
          <span>Read full article</span>
          <span aria-hidden>↗</span>
        </Button>
      </Link>
    </div>
  </article>
);

export default BlogMiniArticleCard;
